import React from 'react';
import { styled } from '@linaria/react';

import { LIGHT_COLORS } from '@/constants';

import Paper from '@/components/Paper';

interface Props {
  num: number;
  state: string;
  code: string;
  snippet: React.ReactElement;
  transform: string;
}

function Snapshot({ num, state, snippet, transform }: Props) {
  const [appliedTransform, setAppliedTransform] = React.useState(
    'translate(0%, 0%) rotate(0deg)'
  );

  React.useEffect(() => {
    setAppliedTransform(transform);
  }, [transform]);

  return (
    <Wrapper style={{ transform: appliedTransform }}>
      <Title>— Snapshot #{num} —</Title>
      <State>{state}</State>
      {snippet}
    </Wrapper>
  );
}

const Wrapper = styled(Paper)`
  isolation: isolate;
  box-shadow:
    0px 1px 2px hsl(0deg 0% 0% / 0.2),
    0px 2px 4px hsl(0deg 0% 0% / 0.16),
    0px 4px 8px hsl(0deg 0% 0% / 0.12),
    0px 8px 16px hsl(0deg 0% 0% / 0.08),
    0px 16px 32px hsl(0deg 0% 0% / 0.07);
  border-radius: 8px;
  text-align: center;
  max-width: 425px;
  padding: 16px;
  transition: transform 500ms;
  pointer-events: auto;
  background: var(--color-original-white);
`;

const Title = styled.p`
  font-size: 1.25rem;
  font-weight: var(--font-weight-medium);
`;

const State = styled.p`
  margin-bottom: 16px;
  font-size: 0.75rem;
  white-space: pre-wrap;
  color: hsl(260deg 45% 28%);
  font-family: var(--font-family-mono);
  text-align: center;
`;

export default Snapshot;
